/**
 * @generated SignedSource<<5dd1632fd216eaa19f7dac62b28b319d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicCollectionDescriptionTopic$data = {
  readonly description: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly " $fragmentType": "topicCollectionDescriptionTopic";
};
export type topicCollectionDescriptionTopic$key = {
  readonly " $data"?: topicCollectionDescriptionTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicCollectionDescriptionTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicCollectionDescriptionTopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Collection",
  "abstractKey": null
};

(node as any).hash = "95931cfcba70481b8042da1270319952";

export default node;
